import React from "react";
import './InputText.scss'



const InputText = ({ type="text",title = "title",checked, obligatorio = false, placeholder, id, onChange,value,disabled,className }) => {
    return (
        <div className={`InputText ${className}`}>
            <div className="contenedorTitulo">
                {
                    obligatorio ?
                        <>
                            <div className="obligatorio">*</div>
                        </>:null
                }
                <div className="titulo">{title}</div>
            </div>
            <input checked={checked} type={type} disabled={disabled} value={value} id={id} onChange={onChange} placeholder={placeholder}  className={`InputText `} />
        </div>
    )
}
export default InputText